import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import clsx from 'clsx';
import { makeStyles, Theme } from '@material-ui/core';
import colors from '../../styles/variables/baseColors.module.scss'; // bridge from scss variables to js

export enum badgeType {
  badge = 'badge', // text with a colored background
  text = 'text' // text tag
}

interface StyleConfig {
  type: badgeType;
}
  
interface Props {
  className?: string;
  intl: { formatMessage: Function };
  type: badgeType;
}

const messages = defineMessages({
  betaBadge: { id: 'badge.beta', defaultMessage: 'BETA' }
});

const BetaBadge = (props: Props) => {
  const { className, intl, type } = props;
  const classes = useStyles({ type });
  
  return (
    <div className={clsx(classes.labelBadge, className)}>{intl.formatMessage(messages.betaBadge)}</div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  labelBadge: {
    backgroundColor: (config: StyleConfig) => config.type === badgeType.text ? 'transparent' : colors.lifesize,
    borderRadius: 2,
    color: (config: StyleConfig) => config.type === badgeType.text ? colors.lifesize : colors.white,
    fontSize: '0.8em',
    fontWeight: 'bold',
    marginLeft: theme.spacing(1),
    padding: '0.25em 1em 0.1em',
    textTransform: 'uppercase'
  }
}));

export default injectIntl(BetaBadge);
